let weChatScriptPromise = null

export function isWeChatBrowser() {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') !== -1
}

export function loadWeChatSdk() {
  if (window.wx) {
    return Promise.resolve(window.wx)
  }

  if (weChatScriptPromise) {
    return weChatScriptPromise
  }

  weChatScriptPromise = new Promise((resolve, reject) => {
    const script = document.createElement('script')
    script.src = 'https://res.wx.qq.com/open/js/jweixin-1.6.0.js'
    script.async = true
    script.onload = () => {
      if (window.wx) {
        resolve(window.wx)
      } else {
        reject(new Error('微信 SDK 加载失败'))
      }
    }
    script.onerror = () => reject(new Error('微信 SDK 加载失败'))
    document.head.appendChild(script)
  })

  return weChatScriptPromise
}

export function getShareLink(path) {
  const origin = window.location.origin
  const basePath = window.location.pathname
  if (basePath.indexOf('/index.html') !== -1) {
    return `${origin}${basePath}#${path}`
  }
  return `${origin}/index.html#${path}`
}

export function buildActivityShareData(activityInfo) {
  const title = activityInfo.contentTitle || activityInfo.subject || '活动详情'
  const descParts = []
  if (activityInfo.signUpStartTime || activityInfo.signUpEndTime) {
    descParts.push(`报名：${formatDateTime(activityInfo.signUpStartTime)}-${formatDateTime(activityInfo.signUpEndTime)}`)
  }
  if (activityInfo.startTime || activityInfo.endTime) {
    descParts.push(`活动：${formatDateTime(activityInfo.startTime)}-${formatDateTime(activityInfo.endTime)}`)
  }

  return {
    title,
    desc: descParts.filter(Boolean).join(' ') || '点击查看活动详情',
    imgUrl: activityInfo.contentUrl || activityInfo.coverUrl || '',
    link: getShareLink(`/socialActivities/${activityInfo.id}`)
  }
}

export async function initWeChatShare({ getConfig, title, desc, link, imgUrl }) {
  const wx = await loadWeChatSdk()
  const config = await getConfig(link.split('#')[0] + '#' + (link.split('#')[1] || ''))
  return new Promise((resolve, reject) => {
    wx.config({
      debug: false,
      appId: config.appId,
      timestamp: config.timestamp,
      nonceStr: config.nonceStr,
      signature: config.signature,
      jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
    })

    wx.ready(() => {
      const shareData = {
        title,
        desc,
        link,
        imgUrl
      }
      if (wx.updateAppMessageShareData) {
        wx.updateAppMessageShareData(shareData)
      }
      if (wx.updateTimelineShareData) {
        wx.updateTimelineShareData({
          title,
          link,
          imgUrl
        })
      }
      resolve(wx)
    })

    wx.error(err => {
      reject(err)
    })
  })
}

export async function copyShareLink(link) {
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(link)
    return true
  }

  const textarea = document.createElement('textarea')
  textarea.value = link
  textarea.style.position = 'fixed'
  textarea.style.opacity = '0'
  document.body.appendChild(textarea)
  textarea.select()
  const success = document.execCommand('copy')
  document.body.removeChild(textarea)
  return success
}

export async function shareOrCopyLink(link, title) {
  if (navigator.share) {
    try {
      await navigator.share({ title, url: link })
      return 'shared'
    } catch (error) {
      if (error && error.name === 'AbortError') {
        return 'cancelled'
      }
    }
  }

  await copyShareLink(link)
  return 'copied'
}

function formatDateTime(time) {
  if (!time) return ''
  const date = new Date(time)
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  const hour = String(date.getHours()).padStart(2, '0')
  const minute = String(date.getMinutes()).padStart(2, '0')
  return `${month}-${day} ${hour}:${minute}`
}



// WEBPACK FOOTER //
// ./src/utils/wechatShare.js